import indexPage from '../pages/home/index'
import winners from '../pages/winners/index'
// import passport from './passport/index'
// import course from './course/index'
// import my from './my/index'
// import teacher from './teacher/index'
// import page404 from './error/404'
// import mqtt from '../pages/mqtt/index'

const routes = [
  {
    path: '/',
    name: 'index',
    component: indexPage,
    props: true,
    meta: {
      title: '王者财经首届520王粉节来啦，全场福利大放送，狂欢嗨不停！'
    }
  },
  {
    path: '/winners/:cId(\\d+)',
    name: 'winners',
    component: winners,
    props: true,
    meta: {
      title: '斗K大联欢中奖名单'
    }
  },
  // passport,
  // course,
  // my,
  // teacher,
  // page404,
  //   {
  //     name: 'page404',
  //     path: '*',
  //     component: page404,
  //     props: true,
  //     meta: {
  //       title: 'Page 404'
  //     }
  //   }
  {
    path: '*',
    redirect: '/'
  }
]

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '')
  // console.log(route.path);
})

export default routes
